/**
 * Phase 18.16-B Batch 1 — /sea-freight + /zeevracht (CMS-driven).
 *
 * Now powered by the generic ServicePageCmsWrapper that reads
 * `service_page_settings` + `service_page_cards` rows for slug
 * "sea-freight". The legacy `zeevracht` CMS blocks remain in the
 * Backoffice (marked "Vervangen") for historical reference.
 */
import React from "react";
import SEO from "../components/SEO";
import QuoteForm from "../components/QuoteForm";
import ServicePageCmsWrapper from "../components/ServicePageCmsWrapper";

const SEA_FREIGHT_FALLBACK = {
  page_banner: {
    eyebrow: "Zeevracht",
    title: "Zeevracht naar de",
    highlight: "Caribbean",
    subtitle: "Verzend dozen, pallets, verhuisgoederen, voertuigen en zakelijke cargo voordelig per zeevracht vanuit Nederland naar de Caribbean.",
    badges: [
      { icon: "ship", label: "Container & groupage" },
      { icon: "shield", label: "Verzekerd en getrackt" },
      { icon: "support", label: "Persoonlijk support" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Voor wie geschikt",
    title: "Voordelig verschepen — voor particulier én zakelijk",
    subtitle: "Zeevracht is de slimste keuze voor zwaardere zendingen, verhuisgoederen of grotere volumes. Vertrekken zijn periodiek; transittijd is afhankelijk van vertrekdatum, documenten, douane en lokale afhandeling.",
  },
  cta_band: {
    title: "Klaar voor uw zeevracht?",
    description: "Vraag direct een offerte aan — antwoord binnen 1 werkdag.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons direct",
    cta_secondary_url: "tel:+31488235999",
  },
  cards: [],
};

export default function SeaFreightPage() {
  return (
    <>
      <SEO
        title="Zeevracht naar de Caribbean | 5999Cargo"
        description="Verzend dozen, pallets, verhuisgoederen, voertuigen en zakelijke cargo per zeevracht vanuit Nederland naar de Caribbean."
      />
      <ServicePageCmsWrapper
        slug="sea-freight"
        fallback={SEA_FREIGHT_FALLBACK}
        testid="sea-freight-page"
        bottomChildren={
          <section id="quote-section" className="relative overflow-hidden bg-[#082c50] text-white py-20 lg:py-24" data-testid="quote-section">
            <div className="absolute inset-0">
              <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-cyan-400/10 blur-3xl" />
              <div className="absolute -bottom-32 right-0 w-[40rem] h-[40rem] rounded-full bg-[#1a5193]/30 blur-3xl" />
            </div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-md text-[11px] uppercase tracking-[0.18em] font-chivo font-bold text-cyan-100">
                  Offerte
                </span>
                <h2 className="font-chivo font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-tight">
                  Vraag direct een{" "}
                  <span className="bg-gradient-to-r from-cyan-300 via-sky-300 to-white bg-clip-text text-transparent">
                    zeevracht offerte aan
                  </span>
                </h2>
                <p className="mt-4 text-white/80 text-lg max-w-lg leading-relaxed">
                  Antwoord binnen 1 werkdag — inclusief totale prijs, indicatie levertijd en alle douaneformaliteiten.
                </p>
              </div>
              <div>
                <QuoteForm defaultService="sea-freight" />
              </div>
            </div>
          </section>
        }
      />
    </>
  );
}
